<template>
	<div class="flex justify-stretch gap-3 mt-4 mb-3">
		<app-button
			v-if="prev"
			:to="prev"
			size="large"
			class="w-full text-center"
			data-testid="prev-button">
			{{ current == 1 ? 'Return' : 'Prev' }}
		</app-button>

		<app-button
			v-if="current == 5 && !store.journey!.complete"
			:disabled="disabled"
			size="large"
			theme="info"
			class="w-full text-center"
			data-testid="confirm-button"
			@click="emit('confirmed')">
			Confirm Delivery
		</app-button>

		<app-button
			v-else-if="current != 5 && auth.vehicleLocked"
			:to="method ? undefined : next"
			:disabled="disabled"
			size="large"
			theme="info"
			class="w-full text-center"
			data-testid="next-button"
			@click="navigate">
			Next
		</app-button>
	</div>

	<slot v-if="auth.vehicleLocked || store.journey?.complete"></slot>

	<journey-stepper :current="current" />
</template>

<script lang="ts" setup>
	import JourneyStepper from '@/components/partials/driver-app/JourneyStepper.vue'
	import router from '@/router'
	import useAuthStore from '@/stores/auth'
	import useDriverApp from '@/stores/driver-app'

	const auth = useAuthStore()
	const store = useDriverApp()

	const props = withDefaults(
		defineProps<{
			prev?: string
			next?: string
			current: number
			disabled?: boolean
			method?: Function
		}>(),
		{
			prev: undefined,
			next: undefined,
			current: 1,
			method: undefined
		}
	)

	async function navigate() {
		if (props.method) {
			try {
				await props.method()
				router.push(props.next!)
			} catch (error) {
				console.error('Error preventing navigation: ' + error)
				return
			}
		} else {
			router.push(props.next!)
		}
	}

	const emit = defineEmits(['confirmed', 'next'])
</script>
